import React, { Component } from 'react'
import Translation from '../../Translation/cont/Translation'

const POSITION_LABELS = {
    'top-left':      'social_media_position_top_left',
    'top-center':    'social_media_position_top_center',
    'top-right':     'social_media_position_top_right',
    'center-left':   'social_media_position_center_left',
    'center':        'social_media_position_center',
    'center-right':  'social_media_position_center_right',
    'bottom-left':   'social_media_position_bottom_left',
    'bottom-center': 'social_media_position_bottom_center',
    'bottom-right':  'social_media_position_bottom_right',
}

const GRID_ORDER = [
    'top-left',    'top-center',    'top-right',
    'center-left', 'center',        'center-right',
    'bottom-left', 'bottom-center', 'bottom-right',
]

class PositionGrid extends Component {
    render() {
        const { value, onChange } = this.props
        const labelId = POSITION_LABELS[value]
        return (
            <div className="preset-settings-panel__field">
                <label className="field-label text-small-bold"><Translation id="social_media_position" /></label>
                <div className="preset-pos-grid">
                    <div className="preset-pos-grid__grid">
                        {GRID_ORDER.map(pos => (
                            <button
                                key={pos}
                                type="button"
                                className={`preset-pos-grid__cell${value === pos ? ' preset-pos-grid__cell--active' : ''}`}
                                onClick={() => onChange(pos)}
                            >
                                <span className="preset-pos-grid__dot" />
                            </button>
                        ))}
                    </div>
                    <span className="preset-pos-grid__label text-small-regular">
                        {labelId && <Translation id={labelId} />}
                    </span>
                </div>
            </div>
        )
    }
}

export default PositionGrid
